export const AT_BOTTOM_THRESHOLD = 50;

/**
 * User is at bottom when remaining distance is within the 50px threshold.
 * That includes exact bottom (0) and small overscroll.
 */
export function calculateIsAtBottom(container: {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}): boolean {
  const { scrollTop, scrollHeight, clientHeight } = container;
  const distanceFromBottom = scrollHeight - scrollTop - clientHeight;
  return distanceFromBottom <= AT_BOTTOM_THRESHOLD;
}
